import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import Header from "../Component/Header";
const ProformaForVerificationService = () => {
  useEffect(() => {
    document.title =
      "Proforma For Verification of Service - AF Personnel -  The Air Force School Subroto Park";
  }, []);
  return (
    <>
      <Header />
      <div className="innerslide">
        <ul className="breadcrumb">
          <li>
            <Link to="/"> Home</Link>{" "}
          </li>
          <li> Admissions </li>

          <li>Proforma For Verification of Service - AF Personnel </li>
        </ul>
      </div>
      <div className="innersec">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <h1> Proforma For Verification of Service - AF Personnel </h1>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-6">
              <div className="linktab">
                {" "}
                <Link
                  to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/AF-Personnel.pdf"
                  target="_blank"
                >
                  {" "}
                  Proforma for Verification of Service – AF Personnel
                </Link>{" "}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ProformaForVerificationService;
